import {
  FOOD_PREORDER_EVENT_REPORT_REQUEST,
  FOOD_PREORDER_EVENT_REPORT_SUCCESS,
  FOOD_PREORDER_EVENT_REPORT_FAIL,
} from "./actionType";

export const getFoodPreOrderEventReport = (data) => ({
  type: FOOD_PREORDER_EVENT_REPORT_REQUEST,
  payload: data,
});

export const getFoodPreOrderEventReportSuccess = (data) => ({
  type: FOOD_PREORDER_EVENT_REPORT_SUCCESS,
  payload: data,
});

export const getFoodPreOrderEventReportFail = (error) => ({
  type: FOOD_PREORDER_EVENT_REPORT_FAIL,
  payload: error,
});
